import {Component} from '@angular/core';
import { AppMainComponent} from './app.main.component';
import {trigger, state, transition, style, animate} from '@angular/animations';
import { UserService } from './auth/user.service';

@Component({
    selector: 'app-inline-profile',
    template: `
        <div class="user-profile">
            <div id="sidebar-profile-button">
                <img [routerLink]="'/b/profile'" class="cursor-pointer logo" [src]="user.avatar" />
                <span class="sidebar-profile-name">{{user.name}}</span>
            </div>
        </div>
    `,
    animations: [
        trigger('menu', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppProfileComponent {

    user: any;

    constructor(public userService: UserService) {
        this.user = this.userService.user;
    }

}
